// Constants used for log filtering. To enable/disable particular logs,
// see ../settings.js

// Enables logging of all reflux actions, and their effects on the stores
export const REFLUX_ACTIONS = "REFLUX_ACTIONS"
export const SENTRY_EVENTS = "SENTRY_EVENTS"
export const CURRENT_USER_STORE = "CURRENT_USER_STORE"
export const AUTOMATIC_REDIRECTS = "AUTOMATIC_REDIRECTS"
